import { generateKeys } from '../utils';
import { companies } from './companies';
export const mt4Servers = generateKeys({
    real01: {
        value: 'REAL01',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Real01',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Real01',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Real01',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Real01',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Real01',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Real01',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Real01',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Real01',
        },
    },
    real02: {
        value: 'REAL02',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Real02',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Real02',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Real02',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Real02',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Real02',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Real02',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Real02',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Real02',
        },
    },
    real03: {
        value: 'REAL03',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Real03',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Real03',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Real03',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Real03',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Real03',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Real03',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Real03',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Real03',
        },
    },
    real04: {
        value: 'REAL04',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Real04',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Real04',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Real04',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Real04',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Real04',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Real04',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Real04',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Real04',
        },
    },
    real05: {
        value: 'REAL05',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Real05',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Real05',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Real05',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Real05',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Real05',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Real05',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Real05',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Real05',
        },
    },
    demo: {
        value: 'DEMO',
        name: {
            [companies.bdSwiss.key]: 'VivernoMarkets-Demo01',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Demo01',
            [companies.bdSwissVanuatu.key]: 'BDSwissSC-Demo01',
            [companies.swissMarkets.key]: 'BDSSwissMarkets-Demo01',
            [companies.swissMarketsMauritius.key]: 'BDSSwissMarkets-Demo01',
            [companies.swissMarketsVanuatu.key]: 'BDSSwissMarkets-Demo01',
            [companies.bdSwissSouthAfrica.key]: 'BDSwissGlobal-Demo01',
            [companies.bdSwissComoros.key]: 'BDSwissSC-Demo01',
        },
    },
});
export const mt5Servers = generateKeys({
    Server01: {
        value: 'Server01',
        serverValue: 'SERVER-01',
        name: {
            [companies.bdSwissVanuatu.key]: 'BDSwissGlobal-Server01',
            [companies.bdSwissMauritius.key]: 'BDSwissGlobal-Server01',
        },
    },
    Server02: {
        value: 'Server02',
        serverValue: 'SERVER-02',
        name: {
            [companies.bdSwissComoros.key]: 'BDSInvestments-Server01',
        },
    },
    Server03: {
        value: 'Server03',
        serverValue: 'SERVER-03',
        name: {
            [companies.bdSwissSouthAfrica.key]: 'BDSInvestments-Server03',
        },
    },
    demo: {
        value: 'DEMO',
        serverValue: 'DEMO',
        name: {
            [companies.bdSwissVanuatu.key]: 'BDSwissGlobal-Server01',
            [companies.bdSwissComoros.key]: 'BDSInvestments-Server01',
            [companies.bdSwissSouthAfrica.key]: 'BDSInvestments-Server01',
        },
    },
});
